export const COMPETITION_ID = "-OU0V2cK0VuTgiqM0Pzc";
